module.exports = __webpack_public_path__ + "static/media/product-2.b7a532cf.png";